import { Button } from 'components';
import { Switch } from 'components/Inputs/Switch';
import { TextInput } from 'components/Inputs/TextInput';
import { useManagers } from 'hooks/useManagement';
import { FormProvider, useForm } from 'react-hook-form';
import { managerValidation } from 'schemas';
import { IManagementCreate, ManagementDefaultValues } from 'types/Management';

import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from '@mui/material';

type IManagerDialogForm = {
  isOpen: boolean;
  onClose: () => void;
};

export const ManagementDialogForm: React.FC<IManagerDialogForm> = ({
  isOpen,
  onClose,
}) => {
  const form = useForm({
    defaultValues: ManagementDefaultValues,
    resolver: managerValidation(),
  });

  const { handleOnSubmit, loadingCreate } = useManagers();

  const onSubmit = async (values: IManagementCreate) => {
    const isValid = await handleOnSubmit(values);

    if (!isValid) {
      return;
    }
    form.reset();
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        onClose();
        form.reset();
      }}
    >
      <DialogTitle>
        Cadastrar Responsável do RH
        <IconButton
          aria-label="close"
          onClick={() => {
            onClose();
            form.reset();
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2, pb: 0 }}>
        <Grid container spacing={2}>
          <Grid item>
            <FormProvider {...form}>
              <Box p={2}>
                <Grid container alignItems="flex-start" spacing={3}>
                  <Grid item container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <TextInput
                        required
                        fullWidth
                        name="name"
                        id="name"
                        label="NOME DO COLABORADOR"
                        inputProps={{ maxLength: 60 }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextInput
                        required
                        fullWidth
                        id="email"
                        name="email"
                        label="E-MAIL CORPORATIVO"
                      />
                    </Grid>

                    <Grid item xs={12} md={12} ml={2} mt={2}>
                      <Switch
                        required
                        id="isSuperUser"
                        name="isSuperUser"
                        label="Super Usuário"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </FormProvider>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ pt: 0, pb: 0 }}>
        <Box pb={2} pr={4}>
          <Grid container item spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                onClick={() => {
                  onClose();
                  form.reset();
                }}
              >
                Cancelar
              </Button>
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                disabled={loadingCreate}
                onClick={form.handleSubmit(onSubmit)}
              >
                Salvar
                {loadingCreate && (
                  <CircularProgress
                    size="small"
                    sx={{ width: 24, height: 24, ml: 2 }}
                  />
                )}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
